import {
  isWeightGain
} from "../helpers"

export default (getView) =>
  ({ nextStepPath } = {} ) => ({
    ...getView({
      nextStepPath,
    }),
    mainButton: null,
    stampImage: null,
    finalImage: null,
    isContinueVisible: false,

    init() {
      this.commonInit()

      // Event listener on dom ready
      document.addEventListener("DOMContentLoaded", () => {
        this.mainButton = document.getElementById("mainButton")
        this.stampImage = document.getElementsByClassName(
          "js-personal-commitment-stamper-image",
        )[0]
        this.finalImage = document.getElementsByClassName(
          "js-personal-commitment-stamper-final-image",
        )[0]

        // When animation finishes, hide stamp and show final image
        this.stampImage.addEventListener("animationend", () => {
          this.stampImage.style.display = "none"
          this.finalImage.style.display = "block"
        })
      })

      window.addEventListener("pageshow", (event) => {
        if (event.persisted) {
          this.isContinueVisible = true
        }
      })
    },

    isMetric() {
      return this.store.values.measurementSystem === "metric"
    },

    isWeightGain() {
      return isWeightGain(this.store.values, this.isMetric())
    },

    handleCommitment() {
      this.mainButton.style.display = "none" // Hide button
      this.stampImage.classList.add("animate") // Start animation

      setTimeout(() => {
        // Trigger the event after 4s and redirect to next step
        this.logAnalyticsClickAndRedirect({ clickName: "Commitment Clicked" })
      }, 4000)
    },
  })
